import React from 'react';
import { X } from 'lucide-react';
import { SourceUpload } from './SourceUpload';

interface KnowledgeUploadModalProps {
  scope: 'user' | 'tenant';
  onClose: () => void;
  onUploaded: () => void;
}

export const KnowledgeUploadModal = ({
  scope,
  onClose,
  onUploaded,
}: KnowledgeUploadModalProps) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <button
      type="button"
      aria-label="Close upload"
      onClick={onClose}
      className="absolute inset-0 bg-black/30"
    />
    <div className="relative w-full max-w-lg rounded-lg bg-white shadow-2xl p-6">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h2 className="text-base font-semibold text-[#252F33]">Add source</h2>
          <p className="text-xs text-[#768D95] mt-1">
            {scope === 'tenant'
              ? 'Upload a team-wide text document.'
              : 'Upload a personal text document.'}
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-1 rounded-md hover:bg-slate-100 text-[#768D95]"
          aria-label="Close">
          <X className="h-5 w-5" />
        </button>
      </div>
      <SourceUpload
        scope={scope}
        onUploaded={() => {
          onUploaded();
          onClose();
        }}
      />
    </div>
  </div>
);
